/**
 * Cart Bundle Upsell
 * Converts a nappy cart item to a Nappy + Wipes bundle using Recharge SDK
 */
(function() {
  'use strict';

  // Make init function globally accessible for slide cart AJAX refresh
  window.initCartBundleUpsell = initCartBundleUpsell;

  function initCartBundleUpsell() {
    const buttons = document.querySelectorAll('.cart-bundle-upsell .bundle-upsell-btn');

    if (buttons.length === 0) {
      return;
    }

    buttons.forEach(function(btn, index) {
      // Remove any existing listener to prevent duplicates
      btn.removeEventListener('click', handleBundleUpsellClick);
      btn.addEventListener('click', handleBundleUpsellClick);
    });
  }

  function handleBundleUpsellClick(event) {
    const btn = event.target;
    const container = btn.closest('.cart-bundle-upsell');

    if (!container) {
      return;
    }

    const variantId = container.dataset.variantId;
    const lineIndex = container.dataset.lineIndex;
    const hasSellingPlan = container.dataset.hasSellingPlan === 'true';
    const sellingPlanName = container.dataset.sellingPlanName || '';

    // Check for bundle config
    if (!window.rechargeBundleConfig) {
      alert('Unable to add bundle. Please try again.');
      return;
    }

    const config = window.rechargeBundleConfig;

    // Find matching child variant for the bundle.
    // pantsOnlyVariantId maps a pants-product cart item back to its bundle variant (parentVariantId).
    const variantMap = config.variantMapping.find(function(v) {
      return v.parentVariantId === variantId || v.childVariantId === variantId || v.pantsOnlyVariantId === variantId;
    });

    if (!variantMap) {
      alert('Unable to add bundle - variant not found. Please try again.');
      return;
    }

    // Set loading state
    btn.classList.add('loading');
    btn.textContent = 'Adding bundle...';

    // Store original item for potential restoration
    var originalItem = null;

    // Step 0: Capture cart item details before removal (for restoration if add fails)
    getCartItemDetails(lineIndex)
      .then(function(item) {
        originalItem = item;
        // Step 1: Remove the original item from cart
        return removeFromCart(lineIndex);
      })
      .then(function() {
        // Step 2: Add bundle using Recharge SDK
        return addBundleToCart(config, variantMap, hasSellingPlan, sellingPlanName);
      })
      .then(function() {
        // Step 3: Redirect to checkout with discount
        var checkoutUrl = '/checkout';
        if (window.autoDiscount) {
          checkoutUrl += '?discount=' + window.autoDiscount;
        }
        window.location.href = checkoutUrl;
      })
      .catch(function(error) {
        // Attempt to restore original item if we have it
        if (originalItem) {
          restoreCartItem(originalItem)
            .then(function() {
              btn.classList.remove('loading');
              btn.textContent = 'Bundle with wipes and Save';
              alert('Unable to add bundle. Your original item has been restored to the cart.');
              // Trigger cart update event so UI refreshes
              document.dispatchEvent(new CustomEvent('cart:updated'));
            })
            .catch(function(restoreError) {
              btn.classList.remove('loading');
              btn.textContent = 'Bundle with wipes and Save';
              alert('Unable to add bundle and could not restore your item. Please add it to your cart again.');
            });
        } else {
          btn.classList.remove('loading');
          btn.textContent = 'Bundle with wipes and Save';
          alert('Unable to add bundle. Please try again.');
        }
      });
  }

  function getCartItemDetails(lineIndex) {
    return fetch('/cart.js')
      .then(function(response) {
        if (!response.ok) {
          throw new Error('Failed to fetch cart');
        }
        return response.json();
      })
      .then(function(cart) {
        // lineIndex is 1-based, array is 0-based
        var item = cart.items[parseInt(lineIndex) - 1];
        if (!item) {
          throw new Error('Cart item not found at index ' + lineIndex);
        }
        return item;
      });
  }

  function restoreCartItem(itemDetails) {
    var payload = {
      id: itemDetails.variant_id,
      quantity: itemDetails.quantity,
      properties: itemDetails.properties || {}
    };

    // Restore selling plan if item had one
    if (itemDetails.selling_plan_allocation && itemDetails.selling_plan_allocation.selling_plan) {
      payload.selling_plan = itemDetails.selling_plan_allocation.selling_plan.id;
    }

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ items: [payload] })
    })
    .then(function(response) {
      if (!response.ok) {
        throw new Error('Failed to restore item to cart');
      }
      return response.json();
    });
  }

  function removeFromCart(lineIndex) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        line: parseInt(lineIndex),
        quantity: 0
      })
    })
    .then(function(response) {
      if (!response.ok) {
        throw new Error('Failed to remove item from cart');
      }
      return response.json();
    });
  }

  async function addBundleToCart(config, variantMap, hasSellingPlan, sellingPlanName) {
    // Determine selling plan IDs based on frequency name
    let nappiesSellingPlan = config.nappiesSellingPlan; // default 4 weeks
    let wipesSellingPlan = config.wipesSellingPlan;     // default 4 weeks

    if (hasSellingPlan && sellingPlanName && config.sellingPlanMapping) {
      if (config.sellingPlanMapping[sellingPlanName]) {
        nappiesSellingPlan = config.sellingPlanMapping[sellingPlanName].nappies;
        wipesSellingPlan = config.sellingPlanMapping[sellingPlanName].wipes;
      }
    }

    // Build bundle payload
    var bundle = {
      externalProductId: config.bundleProductId,
      externalVariantId: variantMap.parentVariantId,
      selections: [
        {
          collectionId: config.nappiesCollectionId,
          externalProductId: config.nappyProductId,
          externalVariantId: variantMap.childVariantId,
          quantity: 1
        },
        {
          collectionId: config.wipesCollectionId,
          externalProductId: config.wipesProductId,
          externalVariantId: config.wipesVariantId,
          quantity: 1
        }
      ]
    };

    // Only add selling plans if original item had subscription
    if (hasSellingPlan) {
      bundle.selections[0].sellingPlan = nappiesSellingPlan;
      bundle.selections[1].sellingPlan = wipesSellingPlan;
    }

    // Transform with Recharge SDK
    if (typeof recharge === 'undefined' || !recharge.bundle) {
      throw new Error('Recharge SDK not loaded');
    }

    // Validate bundle before adding to cart
    var dynamicValid = await recharge.bundle.validateDynamicBundle(bundle);
    if (dynamicValid !== true) {
      console.error('TEST:: validateDynamicBundle failed:', dynamicValid);
      throw new Error('Bundle validation failed: ' + dynamicValid);
    }

    var selectionResult = await recharge.bundle.validateBundleSelection(bundle);
    if (!selectionResult.valid) {
      console.error('TEST:: validateBundleSelection failed:', selectionResult.error);
      throw new Error('Bundle selection validation failed: ' + (selectionResult.error || 'Unknown error'));
    }

    var bundleItems = recharge.bundle.getDynamicBundleItems(bundle, config.bundleProductHandle);

    // Add to cart
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ items: bundleItems })
    })
    .then(function(response) {
      if (!response.ok) {
        throw new Error('Failed to add bundle to cart');
      }
      return response.json();
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartBundleUpsell);
  } else {
    initCartBundleUpsell();
  }

  // Re-initialize when cart is updated (for AJAX cart drawers)
  document.addEventListener('cart:updated', function() {
    initCartBundleUpsell();
  });
  document.addEventListener('cart:addons', function() {
    // Delay to allow DOM to update
    setTimeout(initCartBundleUpsell, 100);
  });

  // Also listen for ajaxComplete if jQuery is available (for slide cart AJAX refresh)
  if (typeof jQuery !== 'undefined') {
    jQuery(document).ajaxComplete(function(event, xhr, settings) {
      if (settings.url && settings.url.includes('/cart')) {
        setTimeout(initCartBundleUpsell, 200);
      }
    });
  }

})();
